import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext } from 'react';
import { FirebaseAppContext } from 'libs.firebase_react';
import { Locale } from 'libs.i18n-core';
import { LocalizationStatus } from 'libs.localization.common';
import { useLocalization, useLocalizationExport } from 'libs.localization.react';
import { Spinner } from 'libs.nucleus';
import { useBooleanState } from 'libs.react';
import { useAssetContext } from '../../hooks/use_asset_context.hook';
import { useLocalizationExportSyncV2 } from '../../hooks/use_localization_export_sync_v2.hook';
import { TableExport } from '../export_table';
import { SingleExportTranslationModal } from '../single_export_modal';
export const SectionExport = ({ asset, trackingContext = {}, status }) => {
    const [isModalOpen, openModal, closeModal] = useBooleanState(false);
    const [isModalV2Open, openModalV2, closeModalV2] = useBooleanState(false);
    const { localizationEntry, localization } = useLocalization(asset);
    const { exportLocalization, isFetching: isExporting } = useLocalizationExport();
    const { mutate: exportLocalizationV2, isPending: isExportingV2 } = useLocalizationExportSyncV2();
    let lastExportedAt = localizationEntry?.supported_locales?.[Locale.en_US]?.last_exported_at;
    if (lastExportedAt) {
        lastExportedAt = lastExportedAt?.toDate();
    }
    const locale = localizationEntry?.base_locale ?? Locale.en_US;
    const version = localizationEntry?.supported_locales?.[locale]?.version;
    const { logEvent } = useContext(FirebaseAppContext);
    const { getReviewUrl } = useAssetContext();
    const handleExport = useCallback((resources) => {
        closeModal();
        if (asset && localization) {
            exportLocalization({
                resources,
                locales: [Locale.en_US],
                assets: { [localization?.getId()]: [`${locale}~${version}`] },
            });
            logEvent('translations_base_language_exported', {
                id: asset.id,
                type: asset.type,
                ...trackingContext,
            });
        }
    }, [asset, trackingContext, locale, version]);
    const handleExportV2 = useCallback((resources) => {
        closeModalV2();
        if (asset && localization) {
            exportLocalizationV2({
                resources,
                assets: { [localization?.getId()]: [`${locale}~${version}`] },
            });
            logEvent('translations_base_language_exported', {
                id: asset.id,
                type: asset.type,
                ...trackingContext,
                serviceVersion: 'v2',
            });
        }
    }, [asset, localization, locale, version]);
    if (!asset) {
        return null;
    }
    return (_jsxs("div", { className: 'relative', children: [(isExporting || isExportingV2) && _jsx(Spinner, { wrapper: 'full' }), _jsx(TableExport, { asset: asset, onExportButtonClick: openModal, onExportV2ButtonClick: openModalV2, data: {
                    locale,
                    last_exported: lastExportedAt,
                    status: localizationEntry?.supported_locales?.[locale]?.status || '',
                    currentVersionStatus: {
                        status: localizationEntry?.supported_locales?.[locale]?.status ?? LocalizationStatus.NOT_AVAILABLE,
                        version: localizationEntry?.supported_locales?.[locale]?.version ?? 0,
                    },
                }, isExporting: isExporting || isExportingV2, reviewPath: `${getReviewUrl()}/${Locale.en_US}?assetType=${asset?.type}`, status: status }), isModalOpen && _jsx(SingleExportTranslationModal, { onModalClose: closeModal, onHandleExport: handleExport }), isModalV2Open && _jsx(SingleExportTranslationModal, { onModalClose: closeModalV2, onHandleExport: handleExportV2 })] }));
};
